export const Props = () => ({
  //ID элемента
  id: {
    type: Number,
    default: 0,
  },
  
  //Ссылка на иконку
  icon: {
    type: String,
    default: '',
  },

  //Главный текст
  text: {
    type: String,
    default: '',
  },

  //Второстепенный текст
  subtext: {
    type: String,
    default: '',
  },

  //Применять ли hover к элементу
  isHover:{
    type: Boolean,
    default: false,
  }
});